import { render, staticRenderFns } from "./Patientinfo.vue?vue&type=template&id=6396b2e5&"
import script from "./Patientinfo.vue?vue&type=script&lang=js&"
export * from "./Patientinfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports